import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import LoadingSpinner from "../../LoadingSpinner";
import SearchDropdown from "../../input/SearchDropdown";
import Dropdown from "../../input/Dropdown";
import {
  getBulkDropdownData,
  getFieldValuesByTableAndId,
  getOtherRefSearchDropdown,
  getTextByValueAndKey,
} from "../../../api/keyvalue";
import Button from "../../input/Button";
import Grid from "../../Grid";
import ButtonRenderer from "../../renderer/ButtonRenderer";
import { CustomerShipperValidation } from "../../validations/CustomerShipperCreation";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../renderer/StyleRenderer";
import { toast } from "react-toastify";
import { findCustomerShipperByCustomerAndShipper } from "../../../api/customerShipperAPI";
import { getClusterName } from "../../../api/clusterNameApi";
import { MODULES } from "../../../const";
import Input from "../../input/Input";
import MultiInput from "../../input/MultiInput";
import DeleteButtonRenderer from "../../renderer/DeleteButtonRenderer";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

const CustomerShipperForm = forwardRef(
  ({ dropdown, isLoading, currentValues, editMode }, ref) => {
    const [currentErrors, setCurrentErrors] = useState({});
    const [currentCustomerShipper, setCurrentCustomerShipper] = useState({});

    const [plantWiseEmails, setPlantWiseEmails] = useState([]);

    const [customerShipper, setCustomerShipper] = useState([]);
    const [deletedList, setDeletedList] = useState([]);

    //counter
    const [customerShipperCount, setCustomerShipperCount] = useState(2);

    // flags
    const [searchFieldReset, setSearchFieldReset] = useState(false);
    const [customerFieldReset, setCustomerFieldReset] = useState(false);
    // const [cshFieldReset, setCshFieldReset] = useState(false);
    const [isAddLoading, setIsAddLoading] = useState(false);
    const [buttonClicked, setButtonClicked] = useState(false);
    const [currentCustomerEdit, setCurrentCustomerEdit] = useState(false);

    //dropdown
    const [activeOptions, setActiveOptions] = useState([]);

    const [customerShipperData, setCustomerShipperData] = useState(
      editMode
        ? {
            cshCustomer: currentValues[0].cshCustomerId,
            cshStatus: 2,
            cshActive: 1,
            cshShipper: "",
            cshCluster: "",
            cshEmailList: "",
            cshSmsList: "",
            cshPlatWiseEmails: [],
          }
        : {
            cshCode: "",
            cshReferance: "",
            cshCustomer: "",
            cshShipper: "",
            cshShipperId: "",
            cshDiscription: "",
            cshStatus: 2,
            cshActive: 1,
            customerName: "",
            shipperName: "",
            cshCluster: "",
            clusterName: "",
            cshEmailList: "",
            cshSmsList: "",
            cshPlatWiseEmails: [],
          },
    );

    useEffect(() => {
      (async () => {
        const { active } = await getBulkDropdownData([{ key: "active" }]);
        setActiveOptions(active);
      })();
    }, []);

    useEffect(() => {
      if (Object.keys(currentCustomerShipper).length > 0) {
        if (editMode) {
          setCustomerShipperData({
            ...currentCustomerShipper,
            cshShipper:
              currentCustomerShipper.cshShipperId ??
              currentCustomerShipper.cshShipper,
          });
        } else {
          setCustomerShipperData({
            ...currentCustomerShipper,
          });
        }
      }
      setCurrentCustomerEdit(true);
    }, [editMode, currentCustomerShipper]);

    useEffect(() => {
      (async () => {
        if (editMode && currentValues) {
          let currentCustomerShippers = [];
          let id = 2;
          for (let currentValue of currentValues) {
            const cshStatusValue = await getTextByValueAndKey(
              "status",
              currentValue.cshStatus,
            );
            const cshActiveValue = await getTextByValueAndKey(
              "active",
              currentValue.cshActive,
            );

            const cshClusterValue = await getClusterName(
              currentValue.cshCluster,
            );

            const customer = await getFieldValuesByTableAndId({
              tableName: "masterdata.tms_m_stakeholder",
              primaryKey: "stk_id",
              fieldNames: "stk_name",
              ids: currentValue.cshCustomerId,
            });

            const customerName = customer[0].field1;

            const shipper = await getFieldValuesByTableAndId({
              tableName: "masterdata.tms_m_stakeholder",
              primaryKey: "stk_id",
              fieldNames: "stk_name",
              ids: currentValue.cshShipperId,
            });

            const shipperName = shipper[0].field1;

            currentCustomerShippers.push({
              ...currentValue,
              customerName: customerName,
              shipperName: shipperName,
              ActiveName: cshActiveValue,
              StatusName: cshStatusValue,
              clusterName: cshClusterValue,
              id,
            });

            ++id;
          }
          setCustomerShipperCount(id);
          setCustomerShipper(currentCustomerShippers);
        }
      })();
    }, [editMode, currentValues]);

    const onAddClick = async () => {
      setIsAddLoading(true);

      const customerShipperErrors = CustomerShipperValidation({
        ...customerShipperData,
      });

      if (Object.keys(customerShipperErrors).length === 0) {
        const response =
          await findCustomerShipperByCustomerAndShipper(customerShipperData);

        if (
          Object.keys(currentCustomerShipper).length <= 0 &&
          customerShipper.some(
            (shipper) => shipper?.cshShipper === customerShipperData.cshShipper,
          )
        ) {
          toast.error(
            "There was an error adding customer shipper already added to grid!",
            { autoClose: 5000, containerId: "Main" },
          );
        } else {
          if (!customerShipperData.id && response !== "") {
            toast.error(
              "There was an error adding customer shipper already exists!",
              { autoClose: 5000, containerId: "Main" },
            );
          } else {
            const customer = await getFieldValuesByTableAndId({
              tableName: "masterdata.tms_m_stakeholder",
              primaryKey: "stk_id",
              fieldNames: "stk_name",
              ids: customerShipperData.cshCustomer,
            });

            const customerName = customer[0].field1;

            const shipper = await getFieldValuesByTableAndId({
              tableName: "masterdata.tms_m_stakeholder",
              primaryKey: "stk_id",
              fieldNames: "stk_name",
              ids: customerShipperData.cshShipper,
            });

            const shipperName = shipper[0].field1;

            const StatusName = await getTextByValueAndKey(
              "status",
              customerShipperData.cshStatus,
            );
            const ActiveName = await getTextByValueAndKey(
              "active",
              customerShipperData.cshActive,
            );
            const clusterName = await getClusterName(
              customerShipperData.cshCluster,
            );

            if (!customerShipperData.cshId) {
              if (!customerShipperData.id) {
                setCustomerShipper((prevState) => [
                  ...prevState,
                  {
                    ...customerShipperData,
                    customerName: customerName,
                    shipperName: shipperName,
                    StatusName: StatusName,
                    ActiveName: ActiveName,
                    clusterName: clusterName,
                    id: customerShipperCount,
                    cshPlatWiseEmails: plantWiseEmails,
                  },
                ]);
                setCustomerShipperCount((prevState) => ++prevState);
              } else {
                setCustomerShipper((prevState) =>
                  prevState.filter(
                    (item) => item.id !== customerShipperData.id,
                  ),
                );
                setCustomerShipper((prevState) => [
                  ...prevState,
                  {
                    ...customerShipperData,
                    customerName: customerName,
                    shipperName: shipperName,
                    StatusName: StatusName,
                    clusterName: clusterName,
                    ActiveName: ActiveName,
                    cshPlatWiseEmails: plantWiseEmails,
                  },
                ]);
              }
            } else {
              setCustomerShipper((prevState) =>
                prevState.filter(
                  (item) => item.cshId !== customerShipperData.cshId,
                ),
              );

              setCustomerShipper((prevState) => [
                ...prevState,
                {
                  ...customerShipperData,
                  customerName: customerName,
                  shipperName: shipperName,
                  StatusName: StatusName,
                  ActiveName: ActiveName,
                  clusterName: clusterName,
                  cshPlatWiseEmails: plantWiseEmails,
                  modified: true,
                },
              ]);
            }
            setButtonClicked(true);
          }
        }
      }
      setCurrentErrors(customerShipperErrors);
      setIsAddLoading(false);
    };

    useEffect(() => {
      if (buttonClicked) {
        if (editMode) {
          setCustomerShipperData({
            cshCode: "",
            cshReferance: "",
            cshCustomer: currentValues[0].cshCustomerId,
            cshShipper: "",
            cshDiscription: "",
            cshCluster: "",
            cshStatus: 2,
            cshActive: 1,
            cshEmailList: "",
            cshSmsList: "",
            cshPlatWiseEmails: [],
          });
        } else {
          setCustomerShipperData({
            cshCode: "",
            cshReferance: "",
            cshCustomer: "",
            cshShipper: "",
            cshDiscription: "",
            cshCluster: "",
            cshStatus: 2,
            cshActive: 1,
            cshEmailList: "",
            cshSmsList: "",
            cshPlatWiseEmails: [],
          });
          setCustomerFieldReset(true);
        }
        setPlantWiseEmails([]);
        setButtonClicked(false);
        setSearchFieldReset(true);
        setCurrentCustomerShipper({});
      }
    }, [buttonClicked]);

    useImperativeHandle(ref, () => ({
      getData: () => {
        if (editMode) {
          const updateState = {
            modified: [],
            created: [],
            unmodified: [],
            deleted: deletedList,
          };
          customerShipper.forEach((csh) => {
            if (csh.cshId) {
              if (csh.modified) {
                updateState.modified.push(csh);
              } else {
                updateState.unmodified.push(csh);
              }
            } else {
              updateState.created.push(csh);
            }
          });
          return updateState;
        } else {
          return customerShipper;
        }
      },

      resetForm: () => {
        setButtonClicked(true);
        setCustomerShipper([]);
      },
    }));

    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            className="ui form"
            style={{ overflowY: "auto", height: "75vh" }}
          >
            <div className="ui segment">
              <div className="two fields">
                <SearchDropdown
                  key={1}
                  required={true}
                  threshold={1}
                  editMode={editMode}
                  multiGrid={true}
                  multiGridCurrentValue={customerShipperData.customerName}
                  reset={customerFieldReset}
                  setReset={setCustomerFieldReset}
                  onResultSelect={(data) =>
                    setCustomerShipperData((prevState) => ({
                      ...prevState,
                      cshCustomer: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "customer",
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_stakeholder",
                    primaryKey: "stk_id",
                    fieldName: "stk_name",
                    id: customerShipperData.cshCustomer,
                  }}
                  error={currentErrors.cshCustomer}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { cshCustomer: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  label="Customer"
                  disabled={editMode}
                />
                <SearchDropdown
                  key={2}
                  required={true}
                  editMode={editMode}
                  multiGrid={true}
                  multiGridCurrentValue={customerShipperData.shipperName}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setCustomerShipperData((prevState) => ({
                      ...prevState,
                      cshShipper: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setCustomerShipperData((prevState) => ({
                      ...prevState,
                      cshShipper: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "shipper",
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_stakeholder",
                    primaryKey: "stk_id",
                    fieldName: "stk_name",
                    id: customerShipperData.cshShipper,
                  }}
                  error={currentErrors.cshShipper}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { cshShipper: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  label="Shipper"
                />
              </div>
              <div className="two fields">
                <SearchDropdown
                  key={1}
                  multiGrid={true}
                  multiGridCurrentValue={customerShipperData.clusterName}
                  editMode={editMode}
                  module={MODULES.Master}
                  field="csh_cluster"
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setCustomerShipperData((prevState) => ({
                      ...prevState,
                      cshCluster: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setCustomerShipperData((prevState) => ({
                      ...prevState,
                      cshCluster: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "cluster",
                    value: "",
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_cluster_names",
                    primaryKey: "cln_id",
                    fieldName: "cln_cluster",
                    id: customerShipperData.cshCluster,
                  }}
                  label="Cluster"
                />
                {/* <Dropdown
                  required={true}
                  label="Active"
                  error={currentErrors.cshActive}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { cshActive: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Active"
                  options={activeOptions}
                  style={{ height: "20px" }}
                  value={customerShipperData.cshActive}
                  onChange={(e, data) => {
                    setCustomerShipperData((prevState) => ({
                      ...prevState,
                      cshActive: data.value,
                    }));
                  }}
                /> */}
              </div>
              <div className="two fields">
                <Input
                  label="Email Receiver List (Enter Values in Comma Separately)"
                  error={currentErrors.cshEmailList}
                  // module={MODULES.Master}
                  // form={FORM}
                  // field="lcu_email_receiver_list"
                  // editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { cshEmailList: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="cshEmailList"
                  value={customerShipperData.cshEmailList}
                  onChange={(e) =>
                    setCustomerShipperData((prevState) => ({
                      ...prevState,
                      cshEmailList: e.target.value,
                    }))
                  }
                />
                <Input
                  label="SMS Receiver List (Enter Values in Comma Separately)"
                  error={currentErrors.cshSmsList}
                  // module={MODULES.Master}
                  // form={FORM}
                  // field="lcu_sms_receiver_list"
                  // editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { cshSmsList: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="cshSmsList"
                  value={customerShipperData.cshSmsList}
                  onChange={(e) =>
                    setCustomerShipperData((prevState) => ({
                      ...prevState,
                      cshSmsList: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field">
                <MultiInput
                  value={plantWiseEmails}
                  onChange={setPlantWiseEmails}
                  label={"Plant wise held up"}
                  placeholder={""}
                  regex={EMAIL_REGEX}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "flex-end",
                  gap: "5px",
                }}
              >
                <Button
                  template="reset"
                  onClick={(e) => {
                    setButtonClicked(true);
                  }}
                />
                <Button
                  template="addOrSave"
                  create={Object.keys(currentCustomerShipper).length === 0}
                  onClick={onAddClick}
                  isLoading={isAddLoading}
                />
              </div>
              <Grid
                heading="Customer Shipper"
                config={[
                  {
                    headerName: "Customer",
                    field: "customerName",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Shipper",
                    field: "shipperName",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Cluster",
                    field: "clusterName",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Active",
                    field: "StatusName",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    headerName: "Status",
                    field: "ActiveName",
                    cellRenderer: ActiveCellStyle,
                  },
                  {
                    field: "Edit",
                    filter: true,
                    cellRenderer: ButtonRenderer,
                    cellRendererParams: (params) => ({
                      clickHandler: () => {
                        setCurrentCustomerShipper({
                          ...params.data,
                          cshCustomer:
                            params.data.cshCustomer ??
                            params.data.cshCustomerId,
                        });
                        setPlantWiseEmails(params.data.cshPlatWiseEmails ?? []);
                      },
                      label: "Edit",
                    }),
                  },
                  {
                    field: "Delete",
                    filter: true,
                    cellRenderer: DeleteButtonRenderer,
                    cellRendererParams: (params) => ({
                      clickHandler: () => {
                        if (params.data.cshId && params.data.cshId !== null) {
                          setDeletedList((prevState) => [
                            ...prevState,
                            params.data.cshId,
                          ]);
                        }
                        setCustomerShipper((prevState) =>
                          prevState.filter(
                            (customerShipper) =>
                              customerShipper.id !== params.data.id,
                          ),
                        );
                      },
                      message:
                        "Are you sure you want to delete this Customer Shipper?",
                      label: "Delete",
                      className: "ui red button",
                    }),
                  },
                ]}
                content={customerShipper}
              />
            </div>
          </form>
        )}
      </>
    );
  },
);

export default CustomerShipperForm;
